<template>
	<div v-if="componentLoader" class="position-relative h-100">
		<app-overlay-loader />
	</div>
	<div v-else>
		<app-overlay-loader v-if="preloader" />
		<form
			class="mb-0"
			v-else
			ref="form"
			:data-url="`transaction/parent/${value?.id}`"
			:class="{ 'loading-opacity': preloader }"
		>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_name"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							First Name
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_name"
							type="text"
							placeholder="First Name"
							v-model="personalInfoForm.name"
							:required="true"
						/>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_last_name_parents"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							Last Name
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_last_name_parents"
							type="text"
							placeholder="Last Name"
							v-model="personalInfoForm.last_name_parents"
							:required="true"
						/>
					</div>
				</div>
			</div>
			<!-- <div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_email_parents"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							Email
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_email_parents"
							type="email_parents"
							placeholder="Email"
							v-model="personalInfoForm.email_parents"
						/>
					</div>
				</div>
			</div> -->
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label class="text-left d-block mb-lg-2 mb-xl-0"
							>Gender</label
						>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							type="radio"
							:list="genderList"
							v-model="personalInfoForm.gender_parents"
						/>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_contact"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							Contact Number
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_contact"
							type="tel-input"
							v-model="personalInfoForm.contact"
							placeholder="Contact Number"
						/>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_whatsapp"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							WhatsApp Number
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_whatsapp"
							type="tel-input"
							v-model="personalInfoForm.whatsapp"
							placeholder="WhatsApp Number"
						/>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_email_parents"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							Email
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_email_parents"
							type="email"
							v-model="personalInfoForm.email_parents"
							placeholder="Email"
						/>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="row">
					<div class="col-lg-3 col-xl-3 d-flex align-items-center">
						<label
							for="inputs_address_parents"
							class="text-left d-block mb-lg-2 mb-xl-0"
						>
							Address
						</label>
					</div>
					<div class="col-lg-8 col-xl-8">
						<app-input
							id="inputs_address_parents"
							type="textarea"
							v-model="personalInfoForm.address_parents"
							placeholder="Address"
						/>
					</div>
				</div>
			</div>
			<div class="form-group mb-0 mt-5">
				<div class="row">
					<div class="col-12 action-buttons">
						<button
							type="button"
							class="btn btn-primary mr-2"
							@click.prevent="submit"
						>
							{{ $t("save") }}
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import GlobalHelperMixin from "../../../../../Mixins/global/GlobalHelperMixin";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { UserMixin } from "../../../Auth/Mixins/UserMixin";
import * as actions from "../../../../../Config/ApiUrl";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";

export default {
	name: "PersonalInformation",
	extends: AppLibrary,
	mixins: [FormMixin, UserMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			personalInfoForm: {
				name: "",
				last_name_parents: "",
				email_parents: "",
				gender_parents: "",
				contact: "",
				whatsapp: "",
				email_parents: "",
				address_parents: "",
			},
			genderList: [
				{
					id: 0,
					value: "Male",
				},
				{
					id: 1,
					value: "Female",
				},
			],
		};
	},
	created() {
		if (this.value) {
			this.personalInfoForm.name = this.value.name || "";
			this.personalInfoForm.last_name_parents =
				this.value.last_name_parents || "";
			this.personalInfoForm.email_parents =
				this.value.email_parents || "";
			this.personalInfoForm.gender_parents =
				this.value.gender_parents || "";
			this.personalInfoForm.contact = this.value.contact || "";
			this.personalInfoForm.whatsapp = this.value.whatsapp || "";
			this.personalInfoForm.email_parents =
				this.value.email_parents || "";
			this.personalInfoForm.address_parents =
				this.value.address_parents || "";
			this.personalInfoForm.is_whatsapp_same_as_contact =
				this.value.is_whatsapp_same_as_contact || false;
		}
	},
	methods: {
		beforeSubmit() {
			this.scrollToTop(true);
			this.preloader = true;
		},
		submit() {
			if (
				this.personalInfoForm.whatsapp == this.personalInfoForm.contact
			) {
				this.personalInfoForm.is_whatsapp_same_as_contact = true;
			} else {
				this.personalInfoForm.is_whatsapp_same_as_contact = false;
			}
			let submitData = this.personalInfoForm;
			this.save(submitData, "transaction/parent/" + this.value?.id);
		},
		afterFinalResponse() {
			this.preloader = false;
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
		},
		afterError(res) {
			this.$toastr.e(res.data.message);
		},
	},
};
</script>
